const formatMoney = (value) => {
  if (value === undefined || value === null || value === "") return "";
  const number = Number(value);
  if (Number.isNaN(number)) return value;
  return number.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatQty = (value) => {
  if (value === undefined || value === null || value === "") return "";
  const number = Number(value);
  if (Number.isNaN(number)) return value;
  return number.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  });
};

const formatDateBr = (value) => {
  if (!value) return "";
  const [year, month, day] = value.split("-");
  if (!year || !month || !day) return value;
  return `${day}/${month}/${year}`;
};

const paginateItems = (items, firstPageCount = 8, nextPageCount = 12) => {
  const safeItems = Array.isArray(items) ? items : [];
  const pages = [];

  pages.push(safeItems.slice(0, firstPageCount));

  let start = firstPageCount;
  while (start < safeItems.length) {
    pages.push(safeItems.slice(start, start + nextPageCount));
    start += nextPageCount;
  }

  return pages.length ? pages : [[]];
};

export const mapParsedNfeToDanfeData = (parsed) => {
  const itensDanfe = (parsed.itens || []).map((item) => ({
    codigo: item.material || "",
    descricao: item.descriptionMaterial || "",
    ncm: item.ncm || "",
    cst: item.cst || "",
    cfop: item.cfop || "",
    un: item.ucom || "",
    qtde: formatQty(item.qty),
    precoUnit: formatMoney(item.unitValue),
    precoTotal: formatMoney(item.value),
    bcIcms: formatMoney(item.bcIcms),
    vlrIcms: formatMoney(item.vlrIcms),
    vlrIpi: formatMoney(item.vlrIpi),
    aliqIcms: formatMoney(item.aliqIcms),
    aliqIpi: formatMoney(item.aliqIpi),
  }));

  return {
    numero: parsed.ide?.number || "",
    serie: parsed.ide?.serie || "",
    tipoEntradaSaida: parsed.ide?.tpNF || "1",
    naturezaOperacao: parsed.ide?.natOp || "",
    protocolo: parsed.protocolo?.numero || parsed.protocolo?.status || "",
    chaveAcesso: parsed.accesskey || "",

    emitente: {
      nome: parsed.emitente?.nome || "",
      endereco: parsed.emitente?.endereco || "",
      municipioUf: [parsed.emitente?.municipio, parsed.emitente?.uf]
        .filter(Boolean)
        .join(" - "),
      fone: parsed.emitente?.fone || "",
      ie: parsed.emitente?.ie || "",
      im: parsed.emitente?.im || "",
      ieSubst: parsed.emitente?.ieSubst || "",
      cnpj: parsed.emitente?.cnpj || parsed.emitente?.cpf || "",
    },

    destinatario: {
      nome: parsed.destinatario?.nome || "",
      cnpj: parsed.destinatario?.cnpj || parsed.destinatario?.cpf || "",
      endereco: parsed.destinatario?.endereco || "",
      bairro: parsed.destinatario?.bairro || "",
      cep: parsed.destinatario?.cep || "",
      municipio: parsed.destinatario?.municipio || "",
      uf: parsed.destinatario?.uf || "",
      foneFax: parsed.destinatario?.fone || "",
      ie: parsed.destinatario?.ie || "",
      dataEmissao: formatDateBr(parsed.ide?.issueDate),
      dataSaida: formatDateBr(parsed.ide?.outDate),
      horaSaida: parsed.ide?.outTime || parsed.ide?.issueTime || "",
    },

    faturas: (parsed.faturas || []).map((fat) => ({
      numero: fat.numero || "",
      vencimento: formatDateBr(fat.vencimento),
      valor: formatMoney(fat.valor),
    })),

    imposto: {
      baseIcms: formatMoney(parsed.total?.baseIcms),
      valorIcms: formatMoney(parsed.total?.valorIcms),
      baseIcmsSt: formatMoney(parsed.total?.baseIcmsSt),
      valorIcmsSt: formatMoney(parsed.total?.valorIcmsSt),
      valorImportacao: formatMoney(parsed.total?.valorImportacao),
      valorIcmsUfRemet: formatMoney(parsed.total?.valorIcmsUfRemet),
      valorFcpUfDest: formatMoney(parsed.total?.valorFcpUfDest),
      valorProdutos: formatMoney(parsed.total?.valorProdutos),
      valorFrete: formatMoney(parsed.total?.valorFrete),
      valorSeguro: formatMoney(parsed.total?.valorSeguro),
      desconto: formatMoney(parsed.total?.desconto),
      outrasDespesas: formatMoney(parsed.total?.outrasDespesas),
      valorIpi: formatMoney(parsed.total?.valorIpi),
      valorIcmsUfDest: formatMoney(parsed.total?.valorIcmsUfDest),
      valorTributos: formatMoney(parsed.total?.valorTributos),
      valorNota: formatMoney(parsed.total?.valorNota),
    },

    transportador: {
      nome: parsed.transporte?.nome || "",
      freteConta: parsed.transporte?.freteConta || "",
      codigoAntt: parsed.transporte?.codigoAntt || "",
      placa: parsed.transporte?.placa || "",
      ufPlaca: parsed.transporte?.ufPlaca || "",
      cnpjCpf: parsed.transporte?.cnpjCpf || "",
      endereco: parsed.transporte?.endereco || "",
      municipio: parsed.transporte?.municipio || "",
      uf: parsed.transporte?.uf || "",
      ie: parsed.transporte?.ie || "",
      quantidade: parsed.transporte?.quantidade || "",
      especie: parsed.transporte?.especie || "",
      marca: parsed.transporte?.marca || "",
      numeracao: parsed.transporte?.numeracao || "",
      pesoBruto: formatMoney(parsed.transporte?.pesoBruto),
      pesoLiquido: formatMoney(parsed.transporte?.pesoLiquido),
    },

    dadosAdicionais: {
      observacoes: parsed.dadosAdicionais?.observacoes || "",
      reservadoFisco: parsed.dadosAdicionais?.reservadoFisco || "",
      rodapeDir: new Date().toLocaleString("pt-BR"),
      rodapeSistema: "Gerado pelo sistema",
    },

    itens: itensDanfe,
    itemsPages: paginateItems(itensDanfe),
  };
};